import { useEffect } from "react";
import { Link } from "react-router-dom";
import { SuiteNav } from "./SuiteNav";

export function SuiteLayout({ children, credits, title }) {
  useEffect(() => {
    window.scrollTo(0, 0);
    if (title) document.title = `${title} · AI Image Suites`;
  }, [title]);
  return (
    <div className="suite-root min-h-screen bg-[#080B10] text-slate-300 relative overflow-x-hidden" data-testid="suite-layout">
      <div className="suite-grid pointer-events-none absolute inset-0 opacity-60" />
      <div className="pointer-events-none absolute -top-40 -left-40 w-[520px] h-[520px] rounded-full bg-cyan-500/20 blur-[120px]" />
      <div className="pointer-events-none absolute top-40 -right-40 w-[480px] h-[480px] rounded-full bg-purple-600/20 blur-[120px]" />
      <SuiteNav credits={credits} />
      <main className="relative z-10">{children}</main>
      <footer className="relative z-10 border-t border-white/10 mt-24">
        <div className="max-w-7xl mx-auto px-6 py-8 flex flex-wrap gap-6 justify-between text-xs text-slate-500">
          <p>© {new Date().getFullYear()} AI Image Suites · aiimagesuites.pro</p>
          <div className="flex gap-5">
            <Link to="/sessions" className="hover:text-cyan-300" data-testid="footer-capture">Capture app</Link>
            <Link to="/workflows/drone" className="hover:text-cyan-300">Drone workflow</Link>
            <Link to="/contact" className="hover:text-cyan-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

export const Glass = ({ className = "", children, ...rest }) => (
  <div className={`rounded-2xl border border-white/10 bg-slate-950/60 backdrop-blur-xl shadow-[0_8px_32px_rgba(0,0,0,0.37)] ${className}`} {...rest}>
    {children}
  </div>
);

export const GradientText = ({ children }) => (
  <span className="bg-gradient-to-r from-cyan-300 via-purple-400 to-emerald-300 bg-clip-text text-transparent">{children}</span>
);

export const NeonButton = ({ className = "", children, ...rest }) => (
  <button className={`inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full font-semibold text-white bg-gradient-to-r from-cyan-500 via-purple-600 to-emerald-500 shadow-[0_0_24px_rgba(147,51,234,0.35)] hover:shadow-[0_0_34px_rgba(0,242,254,0.5)] hover:-translate-y-0.5 transition-[transform,box-shadow] disabled:opacity-50 disabled:hover:translate-y-0 ${className}`} {...rest}>
    {children}
  </button>
);

export const GhostButton = ({ className = "", children, ...rest }) => (
  <button className={`inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full border border-white/15 text-slate-200 hover:border-cyan-400/60 hover:text-white transition-colors disabled:opacity-50 ${className}`} {...rest}>
    {children}
  </button>
);
